<app-pageheader [Parent]="this">
  <app-form-save-button [Parent]="this" [Form]="Form" class="button is-primary" (OnSave)="Save()">
  </app-form-save-button>
</app-pageheader>

<app-loader [Parent]="this"></app-loader>
@if (FormLoaded) {
  <div [formGroup]="Form">
    <div class="columns">
      <div class="column is-6">
        <article class="panel">
          <p class="panel-heading">Infringement Type</p>
          <div class="panel-block is-block">
            <app-field Label="Name">
              <div class="control">
                <input formControlName="Name" class="input" type="text" />
                <app-validator [For]="Form.get('Name')"></app-validator>
              </div>
            </app-field>
            <app-field Label="Description">
              <div class="control">
                <textarea formControlName="Description" class="textarea"></textarea>
              </div>
            </app-field>
            <app-field Label="Base Fine">
              <div class="control">
                <app-currency-input formControlName="BaseFine"></app-currency-input>
                <app-validator [For]="Form.get('BaseFine')"></app-validator>
              </div>
            </app-field>
            <div class="field is-grouped">
              <div class="control">
                <label class="checkbox">
                  <input type="checkbox" formControlName="IsActive" />
                  Active
                </label>
              </div>
              <div class="control">
                <label class="checkbox">
                  <input type="checkbox" formControlName="AppealEligible" />
                  Appeal Eligible
                </label>
              </div>
            </div>
          </div>
        </article>
      </div>
      <div class="column is-6">
        <article class="panel">
          <p class="panel-heading">Pricing Schedule</p>
          <div class="panel-block is-block">
            <table class="table is-fullwidth" formArrayName="Escalations">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Days After Issuance</th>
                  <th>Additional Fee</th>
                  <th>Description</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                @for (escalation of escalations.controls; track escalation; let i = $index) {
                  <tr [formGroupName]="i">
                    <td>
                      <input formControlName="Sequence" class="input is-small" type="number" min="1" />
                    </td>
                    <td>
                      <input formControlName="DaysAfterIssuance" class="input is-small" type="number" min="0" />
                    </td>
                    <td>
                      <app-currency-input formControlName="AdditionalFee" size="small" [AllowNegative]="true"></app-currency-input>
                    </td>
                    <td>
                      <input formControlName="Description" class="input is-small" type="text" />
                    </td>
                    <td class="has-text-right">
                      <button class="button is-small is-danger" type="button" (click)="removeEscalation(i)" [disabled]="escalations.length <= 1">
                        <span class="icon"><i class="fa fa-trash"></i></span>
                      </button>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
            <button class="button is-link is-light" type="button" (click)="addEscalation()">
              <span class="icon"><i class="fa fa-plus"></i></span>
              <span>Add Escalation</span>
            </button>
          </div>
        </article>
      </div>
    </div>
  </div>
}


